import React, { createContext, useContext } from "react";
import { usePermissions } from "../hooks/usePermissions";

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const permissionsData = usePermissions();

  return (
    <PermissionsContext.Provider value={permissionsData}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissionsContext = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissionsContext must be used within a PermissionsProvider');
  }
  return context;
}; 